export const DEFAULT_FLOW_DATA = {
    id: '',
    name: '',
    schema: {
        name: '',
        sections: [],
        context_schema: [],
    },
    assigned_agents: null,
    created_at: '',
    updated_at: '',
};

export const DEFAULT_QUESTION_DATA = {
    text: '',
    type: 'text',
    options: [],
    skippable: false,
    spelling_sensitive: false,
    required: false,
    visConditionSlots: 0,
};

export const DEFAULT_SECTION_DATA = {
    name: '',
    description: '',
    visConditionSlots: 0,
    isSubsection: false,
    isFirstSubsection: false,
};

export const DEFAULT_DECISION_DATA = {
    name: '',
    decisionVariable: '',
    passed: '',
    failed: '',
    visConditionSlots: 0,
};
